<template>
    <div class="container py-4">
        <div v-if="errorCode === 500"
            class="text-center"
        >
            <h1 class="text-black text-lg lg:text-2xl text-center mb-3 mt-4">Unable to load this page!
            </h1>
            <p>Please try again by refreshing or contact your system administrator.</p>
            <img src="@/assets/images/error.png" class="max-w-500 m-auto" :style="imgStyle" alt="Error" />
        </div>
        <div v-else>
            <div v-if="!loading">
                <MostNotMets :stats="stats"/>
                <PracticePerformance class="mt-4" />
            </div>
            <div class="flex items-center justify-center h-20 w-full" v-else>
                <Loader class="w-12 h-12" />
            </div>
        </div>
    </div>
</template>

<script>
import MostNotMets from '@/components/analytics-report/partials/MostNotMets.vue'
import PracticePerformance from '@/components/analytics-report/partials/PracticePerformance.vue'
import Loader from '@/assets/loader.svg'
import camelcaseKeys from 'camelcase-keys'

export default {
    name: "AnalyticsReports",
    components: { PracticePerformance, MostNotMets, Loader },
    data: () => ({
        errorCode: '',
        loading: true,
        stats: {},
        chartData: {},
        practices: []
    }),
    mounted() {
        this.$http
            .get(`/reports/analytics/overview/`)
            .then(({data}) => {
                this.stats = camelcaseKeys(data, {deep: true})
                console.log('AnalyticsReports stats:', this.stats)
                this.errorCode = ''
            })
            .catch(({ response }) => {
                if(response?.status === 403){
                    this.$router.push({ path: '/Dashboard' })
                }
                if(response?.status !== 403 || response?.status !== 200) {
                    this.errorCode = 500
                    this.loading = false
                }
            })
            .finally(() => {
                this.loading = false
            })
    }
}
</script>
